export default "__VITE_ASSET__DZAgMpwF__"